import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button } from '@mui/material';
import { Adjustments as AdjustmentsIcon } from 'assets/icons/adjustments';
import { FilterDialog } from '../../../../../components/mui/FilterDialog';
import useColumns from './useColumns';

export const PayheadFilters = (props) => {
  const { disabled, filters, onFiltersApply, onFiltersClear } = props;
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [columns] = useColumns();
  const baseProperties = columns.filter((column) => column.type);
  return (
    <>
      <div>
        <Box
          sx={{
            alignItems: 'center',
            display: 'grid',
            justifyItems: 'flex-start',
            pr: 2,
          }}
        >
          <Button
            color="primary"
            disabled={disabled}
            onClick={() => setOpenFilterDialog(true)}
            startIcon={<AdjustmentsIcon />}
            variant={filters.length ? 'contained' : 'text'}
          >
            Filter
          </Button>
        </Box>
      </div>
      <FilterDialog
        onApply={onFiltersApply}
        onClear={onFiltersClear}
        onClose={() => setOpenFilterDialog(false)}
        open={openFilterDialog}
        properties={baseProperties}
      />
    </>
  );
};

PayheadFilters.defaultProps = {
  filters: [],
  disabled: false,
};

PayheadFilters.propTypes = {
  disabled: PropTypes.bool,
  filters: PropTypes.instanceOf(Array),
  onFiltersApply: PropTypes.func.isRequired,
  onFiltersClear: PropTypes.func.isRequired,
};
